import { channelPartnerList, states, cities } from "constants/channelPartner";

const initialState = {
  channelPartnerList: {},
  states: {},
  cities: {},
};

const channelPartner = (state = initialState, action) => {
  switch (action.type) {
    case channelPartnerList:
      return { ...state, channelPartnerList: action.payload };

    case states:
      return { ...state, states: action.payload };

    case cities:
      return { ...state, cities: action.payload };

    default:
      return state;
  }
};

export default channelPartner;
